import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import '../../css/reports/reports.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import FidelityContacts from './fidelitycontacts';
import FidelityFavorites from './fidelityfavorites';
import SignalRService from "../../controllers/SignalRService";
import { changeJanusStatus } from '../../redux/parametersSlice';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Contacts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            loaded: false,
            reloadContacts: false,
            reloadFavorites: false
        }

        this.setLoaded = this.setLoaded.bind(this);
        this.contactsClick = this.contactsClick.bind(this);
        this.favoritesClick = this.favoritesClick.bind(this);
        this.campaignsClick = this.campaignsClick.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
        this.setState({ view: "contacts" })
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    setLoaded() {
        this.setState({ reloadContacts: false, reloadFavorites: false });
    }

    handleMessage(event) {
        if (event.data.Method === "MakecallRemote") {
            this.props.changeJanusStatus("makeCall");
            SignalRService.makeCall({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "called": event.data.Called
            });
        }
    }

    contactsClick(e) {
        this.setState({ view: "contacts", reloadContacts: true });
    }

    favoritesClick(e) {
        this.setState({ view: "favorites", reloadFavorites: true });
    }

    campaignsClick(e) {
        this.setState({ view: "campaigns", loaded: true });
    }

    render() {
        return (
            <>
                <Row >
                    <Col lg={1} className={
                        "fs-4 pb-3 " +
                        (this.state.view === "contacts" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                    } onClick={this.contactsClick}>
                        <FontAwesomeIcon icon={duotone('address-book')} /> <span className='chattab'> {this.props.t("contacts")}</span>
                    </Col>
                    <Col lg={1} className={
                        "fs-4 pb-3 " +
                        (this.state.view === "favorites" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                    } onClick={this.favoritesClick}>
                        <FontAwesomeIcon icon={duotone('star')} /> <span className='chattab'> {this.props.t("favorites")}</span>
                    </Col>
                    <Col lg={1} className={
                        "fs-4 pb-3 " +
                        (this.state.view === "campaigns" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                    } onClick={this.campaignsClick}>
                        <FontAwesomeIcon icon={duotone('megaphone')} /> <span className='chattab'> {this.props.t("campaigns")}</span>
                    </Col>
                </Row>
                <Row style={{ display: (this.state.view === "contacts") ? "flex" : "none" }}>
                    <Col>
                        <FidelityContacts reload={this.state.reloadContacts} loaded={this.setLoaded} />
                    </Col>
                </Row>
                <Row style={{ display: (this.state.view === "favorites") ? "flex" : "none" }}>
                    <Col>
                        <FidelityFavorites reload={this.state.reloadFavorites} loaded={this.setLoaded} />
                    </Col>
                </Row>
                {
                    this.state.loaded &&
                    <Row style={{ display: (this.state.view === "campaigns") ? "flex" : "none" }}>
                        <Col className="iframe-rjs" style={{ height: "74vh", right: "12px", padding: 0, margin: 0 }}>
                            <iframe title="contacts" src={this.props.searchForms} width={"100%"} height={"735px"}></iframe>
                        </Col>
                    </Row>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        searchForms: state.parameters.searchForms,
        extension: state.agent.extension,
        userId: state.agent.userId
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(Contacts);